import { styled } from '@mui/material/styles';
import { FC, ReactNode, useMemo } from 'react';
import Box from '@mui/material/Box';
import { shouldForwardProp as sysShouldForwardProp } from '@mui/system';
import AppBarInternalContext, { AppBarInternalContextShape, appBarInternalProdDefault } from './AppBarInternalContext';
import colors from '../theme/colors';

export interface AppBarInternalProps {
  children?: ReactNode;
  isVisible: boolean;
  isProd?: boolean;
}

const AppBarInternalRoot = styled(Box, {
  name: 'O2AppBarInternal',
  slot: 'Root',
  shouldForwardProp: (prop) => sysShouldForwardProp(prop) && prop !== 'isProd',
})<AppBarInternalProps & AppBarInternalContextShape>(({ theme, isVisible, isProd }) => ({
  color: theme.palette.common.white,
  zIndex: theme.zIndex.drawer + 2,
  position: 'relative',
  backgroundColor: isVisible ? (isProd ? colors.internal['500'] : colors.success['700']) : 'transparent',
  '& .MuiButton-root': isProd
    ? { color: theme.palette.common.white }
    : {
        color: theme.palette.common.white,
        // FIXME: GUI-1764
        background: 'none',
      },
}));

/**
 * @deprecated Use `@o2/common-business/AppBarInternal` instead.
 */
const AppBarInternal: FC<AppBarInternalProps> = ({
  isVisible,
  isProd = appBarInternalProdDefault,
  children,
  ...other
}) => {
  const contextValue = useMemo(() => ({ isProd }), [isProd]);

  return (
    <AppBarInternalContext.Provider value={contextValue}>
      <AppBarInternalRoot isVisible={isVisible} isProd={isProd} {...other}>
        {children}
      </AppBarInternalRoot>
    </AppBarInternalContext.Provider>
  );
};

export default AppBarInternal;
